export default __webpack_public_path__ + "static/media/close.08a4fcc7.svg";